import { AlertEvaluationPeriod } from '../../enums/alert-evaluation-period.enum';
import { enumToList } from '../enum-to-list';
import { IdName } from '../../models/id-name.model';

export function getAlertEvaluationPeriod(value: AlertEvaluationPeriod): string {
  switch (value) {
    case AlertEvaluationPeriod.ThreeMonths:
      return 'Last 3 months';
    case AlertEvaluationPeriod.SixMonths:
      return 'Last 6 months';
    case AlertEvaluationPeriod.TwelveMonths:
      return 'Last year';
    case AlertEvaluationPeriod.YearToDate:
      return 'Year to Date';
    case AlertEvaluationPeriod.Custom:
      return 'Specify custom dates';
    default:
      throw new Error(`Unsupported value for AlertEvaluationPeriod: ${value}.`);
  }
}

export function getAlertEvaluationPeriodList(): IdName[] {
  return enumToList(AlertEvaluationPeriod, getAlertEvaluationPeriod);
}
